import { ResourceCategory } from '../models/api/inventoryResource.model';
import { BeautifyDisplayStringPipe } from '../pipes/beautify-display-string/beautify-display-string.pipe';

const customCategoryDisplayNames: Partial<Record<ResourceCategory, string>> = {
  [ResourceCategory.bot]: 'Agent',
};

export function getResourceCategoryColoredIconPath(resourceCategory: ResourceCategory, throwIfMissing = true) {
  switch (resourceCategory) {
    case ResourceCategory.generic:
      return 'assets/images/resource-category-icons/generic-colored.svg';
    case ResourceCategory.environment:
      return 'assets/images/resource-category-icons/environment-colored.svg';
    case ResourceCategory.identity:
      return 'assets/images/resource-category-icons/identity-colored.svg';
    case ResourceCategory.automation:
      return 'assets/images/resource-category-icons/automation-colored.svg';
    case ResourceCategory.application:
      return 'assets/images/resource-category-icons/application-colored.svg';
    case ResourceCategory.connection:
      return 'assets/images/resource-category-icons/connection-colored.svg';
    case ResourceCategory.connector:
      return 'assets/images/resource-category-icons/connector-colored.png';
    case ResourceCategory.dataStorage:
      return 'assets/images/resource-category-icons/data_storage-colored.svg';
    case ResourceCategory.tools:
      return 'assets/images/resource-category-icons/tools-colored.svg';
    case ResourceCategory.bot:
      return 'assets/images/resource-category-icons/bot-colored.svg';
    case ResourceCategory.aiExtension:
      return 'assets/images/resource-category-icons/ai_extension-colored.svg';
    case ResourceCategory.device:
      return 'assets/images/resource-category-icons/device-colored.svg';
    default:
      if (throwIfMissing) {
        throw new Error(`getResourceCategoryColoredIconPath: resource category ${resourceCategory} not supported`);
      }
      return 'assets/images/resource-category-icons/generic-colored.svg';
  }
}

export function getResourceColoredIconPath(resourceCategory: ResourceCategory) {
  return getResourceCategoryColoredIconPath(resourceCategory, false);
}

export function getResourceCategoryIconPath(resourceCategory: ResourceCategory) {
  switch (resourceCategory) {
    case ResourceCategory.generic:
      return 'assets/images/resource-category-icons/generic.svg';
    case ResourceCategory.environment:
      return 'assets/images/resource-category-icons/environment.svg';
    case ResourceCategory.identity:
      return 'assets/images/resource-category-icons/identity.svg';
    case ResourceCategory.automation:
      return 'assets/images/resource-category-icons/automation.svg';
    case ResourceCategory.application:
      return 'assets/images/resource-category-icons/application.svg';
    case ResourceCategory.connection:
      return 'assets/images/resource-category-icons/connection.svg';
    case ResourceCategory.connector:
      return 'assets/images/resource-category-icons/connector.png';
    case ResourceCategory.dataStorage:
      return 'assets/images/resource-category-icons/data_storage.svg';
    case ResourceCategory.tools:
      return 'assets/images/resource-category-icons/tools.svg';
    case ResourceCategory.bot:
      return 'assets/images/resource-category-icons/bot.svg';
    case ResourceCategory.aiExtension:
      return 'assets/images/resource-category-icons/ai_extension.svg';
    case ResourceCategory.device:
      return 'assets/images/resource-category-icons/device.svg';
    default:
      throw new Error(`getResourceCategoryIconPath: resource category ${resourceCategory} not supported`);
  }
}

export function getResourceCategoryDisplayName(
  category: ResourceCategory | string,
  beautifyDisplayStringPipe: BeautifyDisplayStringPipe
): string {
  if (category in customCategoryDisplayNames) {
    return customCategoryDisplayNames[category as ResourceCategory]!;
  }
  return beautifyDisplayStringPipe.transform(category);
}
